<div class="playback">
  <!-- Web Preview -->
  <div #webPreview class="preview video" width="640" height="360" workers="true" webgl="auto"></div>
</div>

<!-- Border -->
@if (status?.record?.record || status?.record?.isWaitingForRecord) {
  <div
    class="rec-border"
    [class.blink]="status?.record?.pauseRecord || status?.record?.isWaitingForRecord"
  ></div>
}

<!-- Rec -->
@if (status?.record?.record) {
  <div class="record">
    <div class="dot"></div>
    <div class="text">REC</div>
  </div>
}

<!-- Timecode -->
@if (timecode) {
  <div class="timecode" #timecode>00:00:00:00</div>
}

